import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "submitButton"]
  static values = {
    requiredCount: { type: Number, default: 3 },
  }

  declare checkboxTargets: HTMLInputElement[]
  declare submitButtonTarget: HTMLButtonElement | HTMLAnchorElement
  declare hasSubmitButtonTarget: boolean
  declare requiredCountValue: number

  connect() {
    this.updateSubmitButtonState()
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.addEventListener("change", () => this.updateSubmitButtonState())
    })
  }

  validate(event: Event) {
    const checkedCount = this.checkboxTargets.filter((cb) => cb.checked).length

    if (checkedCount < this.requiredCountValue) {
      event.preventDefault()
      alert("すべての項目にチェックを入れてください。")
      return false
    }
  }

  handleLinkClick(event: Event) {
    if (this.submitButtonTarget.classList.contains("is-disabled")) {
      event.preventDefault()
    }
  }

  private updateSubmitButtonState() {
    const checkedCount = this.checkboxTargets.filter((cb) => cb.checked).length
    const allChecked = checkedCount >= this.requiredCountValue

    if (this.hasSubmitButtonTarget) {
      const target = this.submitButtonTarget

      // HTMLButtonElementの場合はdisabled属性を使用
      if (target instanceof HTMLButtonElement) {
        target.disabled = !allChecked
      }

      // 共通: is-disabledクラスの切り替え
      if (allChecked) {
        target.classList.remove("is-disabled")
      } else {
        target.classList.add("is-disabled")
      }
    }
  }
}

